import { Prop, Component, h, Listen } from "@stencil/core";

import { SelectOptionChangedEvent } from "@apis/model/form-events";
import { Language } from "@apis/model/languages";
import { SelectOption } from "frontend-kit/atoms/f-select/f-select-model";
import { LanguageSelectorProps } from "./f-language-selector-model";

import config from "../../../environment/environment-config";
import state, { getLanguages } from "@stores/languages.store";

@Component({
  tag: "f-language-selector",
  styleUrl: "f-language-selector.scss",
  shadow: true,
})
export class LanguageSelector {
  @Prop() label: LanguageSelectorProps["label"] = "Bosch Global";
  @Prop() setLanguageUrl: LanguageSelectorProps["setLanguageUrl"] =
    "_s/change-language";
  @Prop() isDisabled: LanguageSelectorProps["isDisabled"];
  @Prop() labelSelect: LanguageSelectorProps["labelSelect"] = "Choose language";
  @Prop() linkUrl: LanguageSelectorProps["linkUrl"] =
    "https://www.bosch.com/websites-worldwide/";
  @Prop() languageList: LanguageSelectorProps["languageList"];
  @Prop() selectedLanguage: LanguageSelectorProps["selectedLanguage"];

  componentWillLoad(): void {
    if (typeof this.languageList === "string") {
      this.languageList = JSON.parse(this.languageList);
    }
    if (typeof this.selectedLanguage === "string") {
      this.selectedLanguage = JSON.parse(this.selectedLanguage);
    }

    if (!this.languageList && state.supportedLanguages.length === 0) {
      getLanguages();
    }
  }

  @Listen("selectOptionChanged")
  handleOptionChanged(event: CustomEvent<SelectOptionChangedEvent>): void {
    const url = config.contextPath + this.setLanguageUrl;
    fetch(url, {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify({ code: event.detail.selectedOptionValue }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      if (response.ok) {
        response.json().then(function (data) {
          if (data && data["url"]) {
            window.location = data.url;
          }
        });
      }
    });
  }

  private mapLanguagesToOptions = (
    selectedLanguage: Language,
    supportedLanguages: Language[]
  ): SelectOption[] => {
    return supportedLanguages.map((language) => {
      return {
        name: language.nativeName,
        value: language.isocode,
        initiallySelected: language.isocode === selectedLanguage.isocode,
      };
    });
  };

  render() {
    const { selectedLanguage, supportedLanguages } = state;
    return (
      <div class="m-language-selector" data-test="language-selector">
        <div class="m-language-selector__part1">
          <f-link
            variant="simple"
            href={this.linkUrl}
            target="_blank"
            data-test="language-selector-link"
          >
            <f-icon iconName="globe" data-test="language-selector-icon" />
            {this.label}
          </f-link>
        </div>
        <div class="m-language-selector__part2">
          <f-select
            hiddenLabel={true}
            label={this.labelSelect}
            variant="small"
            propertyId="language-selector-dropdown"
            disabled={this.isDisabled}
            options={this.mapLanguagesToOptions(
              (this.selectedLanguage as Language) || selectedLanguage,
              (this.languageList as Language[]) || supportedLanguages
            )}
            data-test="language-selector-select"
          />
        </div>
      </div>
    );
  }
}
